import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";
import {withRouter} from "../../lib/react/withRouter";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Eko_Home extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];

    this.state.mna = [];
      this.state.mna.push({ mnid: "mn02", pos: "c1", text: "RAPPORTER", desc: "Rapporter och försälningsunderlag", link: "/tmpl/eko/rps" });
      this.state.mna.push({ mnid: "mn06", pos: "c2", text: "TRANSAKTIONER", desc: "Periodens inslag", link: "/tmpl/eko/trs" });
      this.state.mna.push({ mnid: "mn07", pos: "c2", text: "KVITTON", desc: "Kvitto underlag", link: "/tmpl/eko/kvitton" });
      this.state.mna.push({ mnid: "mn07", pos: "c2", text: "ORDRAR", desc: "Order underlag", link: "/tmpl/eko/orders" });
      this.state.mna.push({ mnid: "mn07", pos: "c2", text: "SWISH", desc: "Swish underlag", link: "/tmpl/eko/swish" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }
  fknGo(url) {
    //alert(row.href);
      this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Produkter</h3>
            <p>Produktfunktioner funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>

    </div>
  );
    }
}
export default withRouter(Eko_Home);
